import React, { useContext } from "react";
import { TScreen, UploadTypeType } from "api/type";

// Import Contexts
import ScreenContext from "contexts/screen";

// Import Components
import {
  PickUploadMethod,
  PoweredByClinicOS,
  TitleBar,
} from "components/index";

type ScreenSelectUploadMethodProps = {
  handleSetUploadType: (uploadType: UploadTypeType) => void;
};

const ScreenSelectUploadMethod: React.FC<ScreenSelectUploadMethodProps> = ({
  handleSetUploadType,
}) => {
  const setScreen = useContext(ScreenContext)[1];

  return (
    <div className="screen-container">
      <TitleBar
        name={"How would you like to see results?"}
        onClickBackButton={() => setScreen(TScreen.SELECT_PROCEDURE_SCREEN)}
      />
      <PickUploadMethod
        onClickScan={() => {
          setScreen(TScreen.BODY_SCAN_INSTRUCTIONS_SCREEN);
          handleSetUploadType(UploadTypeType.SCAN);
        }}
        onClickUpload={() => {
          setScreen(TScreen.PHOTO_UPLOAD_INSTRUCTIONS_SCREEN);
          handleSetUploadType(UploadTypeType.UPLOAD);
        }}
      />
      <PoweredByClinicOS />
    </div>
  );
};

export default ScreenSelectUploadMethod;
